import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { slugify } from '../../../utils/slugify';
import { ServerVarsContext } from '../../../global/ServerVarsContext/ServerVarsContext';

// components
import { FormattedNumber } from 'react-intl';
import { Radio } from 'dibs-elements/exports/Radio';
import { AbsoluteAnchor } from '../../../global/AbsoluteAnchor/AbsoluteAnchor';

//styles
import styles from './SbSharedRefineMenuInput.scss';

export function SbSharedRefineMenuInputRadio(props) {
    const {
        text,
        count,
        className,
        value,
        checked,
        onChange,
        link,
        linkReference,
        linkable,
        isHidden,
    } = props;
    const { isSbTopNavVariant } = useContext(ServerVarsContext);
    const containerClass = classnames(styles.container, className, {
        'is-hidden': isHidden,
    });
    const refetchInFlight = useSelector(state => state.filters.refetchInFlight);
    const anchorClass = classnames(styles.input, {
        [styles.disabled]: refetchInFlight,
    });

    return (
        <div className={containerClass}>
            <AbsoluteAnchor
                href={link}
                linkReference={linkReference}
                linkable={linkable}
                className={anchorClass}
                onClick={e => e.preventDefault()}
            >
                <div onClick={e => e.stopPropagation()}>
                    <Radio
                        labelClass={styles.text}
                        value={value}
                        checked={checked}
                        name={text}
                        label={text}
                        onChange={onChange}
                        dataTn={`facet-content-${slugify(text)}`}
                        disabled={refetchInFlight}
                    />
                </div>
            </AbsoluteAnchor>
            {!isSbTopNavVariant && !!count && (
                <span className={styles.count} data-tn={`facet-count-${slugify(text)}`}>
                    <FormattedNumber value={count} />
                </span>
            )}
        </div>
    );
}

SbSharedRefineMenuInputRadio.propTypes = {
    count: PropTypes.number,
    text: PropTypes.string.isRequired,
    className: PropTypes.string,
    checked: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
    link: PropTypes.string,
    linkReference: PropTypes.string,
    linkable: PropTypes.bool,
    isHidden: PropTypes.bool,
};
